// The solution for rounding number is referenced from this article
// https://www.jacklmoore.com/notes/rounding-in-javascript

export function roundNumber(value: number, decimals: number = 2): number {
  return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
}
